const flatten = val => val.reduce((acc, el) => [...acc, ...Array.prototype.concat(el)], []);

export { flatten };
